import { addmoneySchema } from '../models'
import React, { useContext, useEffect } from 'react'
import { useFormik } from 'formik'
import { Modal } from 'react-bootstrap'
import Swal from 'sweetalert2'
import UserContext from '../context/UserContext'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { addMoneyToWallet } from '../api/apiService'

const QUICK_AMOUNTS = [50, 100, 200, 500, 1000, 2000]

export default function Addmoney({ modal, setModal }) {
  const navigate = useNavigate()
  const infoData = useSelector((state) => state.infoData)
  const context = useContext(UserContext)
  const { setLoader } = context

  const initialValues = {
    amount: '',
  }

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, setFieldTouched } = useFormik({
    initialValues,
    validationSchema: addmoneySchema,
    onSubmit: async (values) => {
      try {
        setLoader(true)
        setModal({ ...modal, addMoney: false })
        
        const redirectUrl = `${window.location.origin}/payment-status`
        const result = await addMoneyToWallet(Number(values.amount), redirectUrl)
        
        if (result.success && result.transaction?.paymentUrl) {
          window.location.replace(result.transaction.paymentUrl)
        } else {
          Swal.fire({
            icon: 'error',
            title: '',
            text: result.message || 'Payment initiation failed',
            footer: 'Alert by the Demon Official Store team',
            confirmButtonColor: '#008ad8',
          })
          setLoader(false)
        }
      } catch (error) {
        setLoader(false)
        console.log(error)
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Something went wrong, please try again leter!',
          footer: 'Alert by the Demon Official Store team',
          confirmButtonColor: '#008ad8',
        })
      }
    },
  })

  useEffect(() => {
    document.title = 'Demon Official Store - Add Money'
    // eslint-disable-next-line
  }, [])

  const closeModal = () => setModal({ ...modal, addMoney: false })

  const selectQuickAmount = (amount) => {
    setFieldValue('amount', String(amount))
    setFieldTouched('amount', true, false)
  }

  const enteredAmount = Number(values.amount) || 0
  const showError = !!errors.amount && touched.amount

  return (
    <Modal centered show={modal.addMoney} backdrop='static' keyboard={false} onHide={closeModal} className='addcoin-modal'>
      <span className='addcoin-sheet-handle'></span>
      <div className='addcoin-header'>
        <h5 className='addcoin-title'>Add Coins</h5>
        <button type='button' className='addcoin-close' aria-label='Close' onClick={closeModal}>
          &times;
        </button>
      </div>
      <form className='addcoin-body' autoComplete='off' onSubmit={handleSubmit}>
        <p className='addcoin-note'>Note: 1 DOS Coin = ₹1</p>

        <span className='addcoin-section-label'>Quick Add</span>
        <div className='quick-add-grid'>
          {QUICK_AMOUNTS.map((amount) => (
            <button
              key={amount}
              type='button'
              className={`quick-add-btn ${enteredAmount === amount ? 'active' : ''}`}
              onClick={() => selectQuickAmount(amount)}
            >
              ₹{amount}
            </button>
          ))}
        </div>

        <label htmlFor='Amount' className='addcoin-section-label'>
          Custom Amount
        </label>
        <div className={`custom-amount-field ${showError ? 'is-invalid' : ''}`}>
          <span className='currency'>₹</span>
          <input
            type='number'
            autoComplete='off'
            name='amount'
            placeholder='Enter amount'
            value={values.amount}
            onChange={handleChange}
            onBlur={handleBlur}
            id='Amount'
            className='custom-amount-input'
          />
        </div>
        {showError ? <p className='addcoin-error'>{errors.amount}</p> : <p className='addcoin-hint'>Minimum amount: ₹1</p>}

        <button type='submit' disabled={isSubmitting || enteredAmount < 1} className='addcoin-submit'>
          {isSubmitting ? (
            <>
              <span className='spinner-border spinner-border-sm me-05' role='status' aria-hidden='true' />
              Loading...
            </>
          ) : (
            `Add ₹${enteredAmount} to Wallet`
          )}
        </button>
      </form>
    </Modal>
  )
}
